import { Box, Flex } from '@mantine/core'

import type { CategorizedAssetsItemProps } from '@/components/@Shared/CategorizedAssetsItem/CategorizedAssetsItem.type'
import { Text } from '@/components/Text/Text'

import { formatMoney } from '@/helpers/formatMoney.helper'

import classes from './CategorizedAssetsItem.module.css'

export function CategorizedAssetsItems({
  accounts,
  icon,
  name,
  total,
}: CategorizedAssetsItemProps) {
  return (
    <Flex className={classes.item}>
      <Flex align="center" gap={16}>
        <Flex className={classes.icon}>{icon({ title: name })}</Flex>

        <Box>
          <Text variant="body_2_medium_black">{name}</Text>
          <Text variant="body_4_gray">{accounts.join(', ')}</Text>
        </Box>
      </Flex>

      <Text variant="body_1_semibold">{formatMoney(total)}</Text>
    </Flex>
  )
}
